export default __webpack_public_path__ + "static/media/Johnson_n_Johnson_2004.2bcd63ad.jpg";